<div class="modal-header d-flex justify-content-between">
    <div class="row thumbs_icon">
      <div class="ml-2">
        <h5 class="modal-title" id="exampleModalLongTitle"><span class="font-weight-bold text_baseline">{{header}}</span>
        </h5>
      </div>
    </div>
  </div>
  <div *ngIf="!isMfaEnabled">
    <div class="modal-body text-center p-3" *ngIf="!isLoading else loader">
      <h5 class="text-center mt-2 mb-2">{{body}}</h5>
  
    </div>
    <ng-template #loader>
      <div class="p-2">
        <app-loading loaderHeight="small"></app-loading>
      </div>
    </ng-template>
  
    <div class="card-footer pb-2 d-flex flex-row-reverse gap-flex" *ngIf="!isError && !isLoading">
      <button (click)="loginAs();" class="btn btn-primary d-flex align-items-center" [disabled]="isLoggin">
        <span *ngIf="isLoggin" class="spinner-border spinner-border-sm mr-2" role="status"
          aria-hidden="true"></span>{{confirmButton}}</button>
      <button (click)="activeModal.close();" [disabled]="isLoggin" class="btn btn-danger float-right ">Cancel</button>
    </div>
  </div>
  <app-multi-factor-auth *ngIf="isMfaEnabled" widthClass="col-md-12 col-xl-12"
    (afterSuccessVerifyOtp)="afterSuccessVerifyOtp($event)" (onError)="onError($event)" native="component"
     [mfaData]="mfaData" [apiName]="apiName" [formData]="formData" [title]="mfaTitle" [content]="mfaContent"
    [showBackButton]="true" (onBack)="onBack($event)" [isFullWidth]="isFullWidth"></app-multi-factor-auth>
